import { render, staticRenderFns } from "./EquipmentTag.vue?vue&type=template&id=6d05d6d3&"
import script from "./EquipmentTag.vue?vue&type=script&lang=js&"
export * from "./EquipmentTag.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d05d6d3')) {
      api.createRecord('6d05d6d3', component.options)
    } else {
      api.reload('6d05d6d3', component.options)
    }
    module.hot.accept("./EquipmentTag.vue?vue&type=template&id=6d05d6d3&", function () {
      api.rerender('6d05d6d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/EquipmentTag.vue"
export default component.exports